export default "__VITE_ASSET__bc79b59c__"